/* Contact email (2026-10-02 preview): the ONE address is NOMARI_CONFIG.contactEmail. Every [data-email] placeholder becomes
   「電郵：」/「Email: 」 + link + 複製 / Copy button, in the current language (re-filled after every language change).
   Link: href="mailto:…" (no-JS fallback; phones/tablets keep it so the Gmail or Mail app opens). Desktop (fine pointer, no touch UA,
   ≥ 768px wide) → swapped to Gmail web compose in a new tab (target=_blank rel=noopener).
   Copy button → copies the address, shows 已複製 / Copied for ~2 s. */
(function(){
  "use strict";
  var C = window.NOMARI_CONFIG || {}, I = window.NomariI18n, EMAIL = C.contactEmail;
  if (!EMAIL) return;
  function en(){ return !!(I && I.current() === "en"); }
  function esc(s){ return String(s).replace(/[&<>"']/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]; }); }
  function isMobile(){
    var ua = navigator.userAgent || "";
    if (/Android|iPhone|iPad|iPod|Mobile|Silk|Kindle/i.test(ua)) return true;
    if (window.matchMedia && (matchMedia("(pointer: coarse)").matches || !matchMedia("(hover: hover)").matches)) return true;   // touch-first (incl. iPadOS "Macintosh" UA)
    return (window.innerWidth || 1024) < 768;
  }
  function gmailUrl(){ return "https://mail.google.com/mail/?view=cm&fs=1&to=" + encodeURIComponent(EMAIL); }
  function setLink(a){
    if (isMobile()){ a.href = "mailto:" + EMAIL; a.removeAttribute("target"); a.removeAttribute("rel"); }
    else { a.href = gmailUrl(); a.target = "_blank"; a.rel = "noopener"; }
  }
  function fill(root){
    Array.prototype.forEach.call((root || document).querySelectorAll("[data-email]"), function(el){
      var lab = en() ? "Email: " : "電郵：", copy = en() ? "Copy" : "複製";
      if (el.__nmLang === (en() ? "en" : "zh")) return;
      el.__nmLang = en() ? "en" : "zh";
      el.setAttribute("data-i18n-skip", "");
      el.innerHTML = (el.hasAttribute("data-email-nolabel") ? "" : '<span class="nm-email-l">' + lab + '</span>') +
        '<a class="nm-email-a" href="mailto:' + esc(EMAIL) + '">' + esc(EMAIL) + '</a> ' +
        '<button type="button" class="nm-copy" data-copy-email aria-label="' + (en() ? "Copy email address" : "複製電郵地址") + '">' + copy + '</button>';
      setLink(el.querySelector("a"));
    });
  }
  function copyText(t){
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(t);
    return new Promise(function(res, rej){
      var ta = document.createElement("textarea"); ta.value = t; ta.setAttribute("readonly", ""); ta.style.position = "fixed"; ta.style.opacity = "0";
      document.body.appendChild(ta); ta.select(); try { document.execCommand("copy") ? res() : rej(); } catch(e){ rej(e); } ta.remove();
    });
  }
  document.addEventListener("click", function(e){
    var b = e.target.closest("[data-copy-email]"); if (!b) return;
    e.preventDefault();
    copyText(EMAIL).then(function(){
      b.textContent = en() ? "Copied" : "已複製"; b.classList.add("copied");
      clearTimeout(b.__t); b.__t = setTimeout(function(){ b.textContent = en() ? "Copy" : "複製"; b.classList.remove("copied"); }, 2000);
    }, function(){ b.textContent = EMAIL; });
  });
  window.addEventListener("resize", function(){ Array.prototype.forEach.call(document.querySelectorAll(".nm-email-a"), setLink); });
  // after every NomariI18n.apply() (app.js re-renders, e.g. the info view) and after a zh/en toggle (onApply chain)
  if (I){
    var a = I.apply; I.apply = function(){ var r = a.apply(this, arguments); fill(document); return r; };
    var prev = I.onApply; I.onApply = function(){ if (prev) prev(); fill(document); };
  }
  fill(document);
  window.NomariContact = { fill: fill, email: EMAIL };
})();
